var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 49,
    viewBox: "0 0 94 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97192 0V48.2679V0ZM21.5459 0V32.8571V0ZM38.1198 0V48.2679V0ZM54.6937 0V9.59543V0ZM71.5584 15.4108V48.2679V15.4108Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 48.2679V0H9.94536V48.2679H0ZM16.5739 32.8571V0H26.5193V32.8571H16.5739ZM33.1479 48.2679V0H43.0932V48.2679H33.1479ZM49.7218 9.59543V0H59.6672V9.59543H49.7218ZM66.5865 48.2679V15.4108H76.5319V48.2679H66.5865Z",
    fill: "#97A2B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7219 48.2673V15.4102H59.6673V48.2673H49.7219Z",
    fill: "#97A2B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2221 9.48643H66.4712V0.109375H93.2221V9.48643Z",
    fill: "#97A2B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitLogo);
export default __webpack_public_path__ + "static/media/mit-logo.dafcc03acda7e4f76aac0efb62cec29d.svg";
export { ForwardRef as ReactComponent };